// extracted by mini-css-extract-plugin
export var menuIcon = "_rb-0";
export var menuIconInline = "_rb-1";